import { render, staticRenderFns } from "./choose-test-record.vue?vue&type=template&id=460b2bc9&scoped=true&"
import script from "./choose-test-record.vue?vue&type=script&lang=js&"
export * from "./choose-test-record.vue?vue&type=script&lang=js&"
import style0 from "./choose-test-record.vue?vue&type=style&index=0&id=460b2bc9&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460b2bc9",
  null
  
)

export default component.exports